function removeAllChildNodes(node?: HTMLDivElement | null): void {
    if (!node) return;

    while (node.firstChild) {
        node.removeChild(node.firstChild);
    }
}

function init(el: HTMLDivElement): void {
    const activeRoot = el.querySelector<HTMLDivElement>('[data-content-scrollers-active-root]');
    const scrollers = el.querySelectorAll<HTMLDivElement>('[data-content-scroller]');

    if (!activeRoot || scrollers.length === 0) return;

    scrollers.forEach((scroller, index) => {
        const heading = scroller.querySelector<HTMLDivElement>('[data-content-scroller-heading]');
        if (!heading) return;

        heading.addEventListener('keydown', (e) => {
            if ([' ', 'Enter'].includes(e.key)) {
                activate(index);
            }
        });
        heading.addEventListener('click', () => {
            activate(index);
        });
    });

    activate(0);

    function activate(index: number): void {
        const active = scrollers.item(index);

        scrollers.forEach((scroller) => scroller.classList.remove('is-active'));
        active.classList.add('is-active');

        const body = active.querySelector<HTMLDivElement>('.content-scroller__side:last-child');
        if (!body) return;

        removeAllChildNodes(activeRoot);
        activeRoot?.appendChild(body.cloneNode(true));
    }
}

window.Drupal.behaviors['contentScroller'] = {
    attach(context: Document | HTMLElement, settings: DrupalSettings) {
        context.querySelectorAll<HTMLDivElement>('[data-content-scrollers]').forEach(init);
    },
};
